import React from 'react';
import { SubmitButton } from 'Components/Fields/Buttons';
import { getDefaultConfig } from 'Utils/Store';
import './MobileWatchNowButton.css';

export const WatchNowButton = ({ buttonText = 'Watch Now', isMobile }) => {
  const { rootDomain } = getDefaultConfig();

  if (isMobile) {
    return (
      <button
        type="button"
        className="mobileContinueWatching"
        onClick={() => {
          window.location.replace(rootDomain);
        }}
      >
        {buttonText}
      </button>
    );
  }
  return (
    <SubmitButton
      className="continueWatching"
      text={buttonText}
      onClick={() => {
        window.location.replace(rootDomain);
      }}
    />
  );
};
